module.exports = __webpack_public_path__ + "media/bootstrap-icons/volume-off-fill-04c59305.svg";